// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// require("@rails/ujs").start()
require("turbolinks").start()
// require("nprogress").start()
// require("@rails/activestorage").start()
require("channels")
// require("custom/script")

// require.context('assets/fonts/', true, /\.(svg|eot|ttf|woff|woff2)$/i)
// require.context('assets/images/', true, /\.(gif|jpg|png|svg)$/i)

// import 'assets/stylesheets/datepicker.css'
// import 'air-datepicker/dist/js/datepicker'
// import 'air-datepicker/dist/js/i18n/datepicker.en'
// import 'bootstrap/dist/css/bootstrap'

// import 'nprogress'
// import 'nprogress.css'
// NProgress.start();
// import 'assets/javascripts/sb-admin-2.min.js'
// import 'assets/stylesheets/style.scss'
import 'assets/stylesheets/components/index.scss'

// import '@fortawesome/fontawesome-free/js/all'
// import '@fortawesome/fontawesome-free/css/all.css'

// import 'nprogress'
// import 'nprogress-turbolinks'
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

Number.prototype.toPriceFormat = function() {
  return this !== 0
    ? Math.round(this)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    : 0;
};